module.exports = __webpack_public_path__ + "img/bg_trabalhista.f776e185.png";